import React, { Component } from 'react';
import _ from 'underscore';

const supportedExtReg = /^doc|docx|odt|rtf|wps|ppt|pptx|odp|dp|xls|xlsx|ods|csv|et|pdf$/i;
const previewUrl = 'https://preview-proxy.udesk.cn/preview';

function stringToHex(str) {
    let hexResult = [];　　　　
    var val = "";　　　　
    for (var i = 0; i < str.length; i++) {
        let hex = str.charCodeAt(i).toString(16);
        hexResult.push(hex);
    }　　　　
    return hexResult.join('');
}

function getPreviewUrl(url, encodeUrl) {
    if (!url) {
        return '';
    }
    if (encodeUrl) {
        url = encodeURIComponent(url);
        url = url.replace(/%2F/g, '/');
    }
    let hexUrl;
    try {
        hexUrl = stringToHex(url);
    } catch (e) {
        console.error('preview-url-helper', e);
        return url;
    }
    return `${previewUrl}/wopi/files/${hexUrl}/documents`;
}

export default class extends Component {
    render() {
        let { file_ext } = this.props;
        let props = _.extend({
            className: 'link',
            target: '_blank'
        }, this.props);
        
        if (supportedExtReg.test(file_ext)) {
            // if (file_ext !== 'pdf') {
            //     props.href += '?yifangyun_preview/v2/ext=' + file_ext;
            // }
            props.href = getPreviewUrl(props.href, true);
        } else {
            props.className += ' disabled';
        }

        return (
            <a {...props}>预览</a>
        )
    }
}


// WEBPACK FOOTER //
// ./src/ui/uploader/preview.js